module.exports = "/_next/static/images/home-main-category-menu-f30e06099ff4e0816d4f98bfa823c1ed.jpg";